import axios from 'axios';
import { useAuthStore } from '../store/authStore';

const baseURL = import.meta.env.VITE_API_URL || '/api';

const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    let token = useAuthStore.getState().token;

    if (!token) {
      token = sessionStorage.getItem('auth_token') || localStorage.getItem('auth_token');
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!error.response) {
      console.error('No se pudo conectar con el servidor');
      return Promise.reject(error);
    }

    const originalUrl = error.config?.url?.toLowerCase() || '';
    const isExportRequest = originalUrl.includes('export');

    if (error.response.status === 401 && !isExportRequest) {
      useAuthStore.getState().logout();
      window.location.replace('/login');
    }

    return Promise.reject(error);
  }
);

export default api;